(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products-carousel"] && !Shopify.designMode) return;
  try {
    
function initializeProductCarousels(root) {
  root.querySelectorAll('[data-product-carousel]').forEach(function(carousel) {
    if (carousel.dataset.carouselReady === 'true') return;
    carousel.dataset.carouselReady = 'true';

    var viewport = carousel.querySelector('[data-carousel-viewport]');
    var track = carousel.querySelector('[data-carousel-track]');
    var items = Array.from(carousel.querySelectorAll('.product-carousel-item'));
    var previousButton = carousel.querySelector('[data-carousel-previous]');
    var nextButton = carousel.querySelector('[data-carousel-next]');
    var controls = carousel.querySelector('.carousel-controls');
    var autoplayEnabled = carousel.dataset.autoplay === 'true';
    var autoplayDelay = Number(carousel.dataset.autoplayDelay) || 4000;
    var autoplayTimer;

    if (!viewport || !track || !previousButton || !nextButton || items.length === 0) {
      if (controls) controls.hidden = true;
      return;
    }

    function hasOverflow() {
      return viewport.scrollWidth > viewport.clientWidth + 2;
    }

    function getStep() {
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return items[0].getBoundingClientRect().width + gap;
    }

    function updateControls() {
      var overflow = hasOverflow();
      controls.hidden = !overflow;
      previousButton.disabled = !overflow || viewport.scrollLeft <= 2;
      nextButton.disabled = !overflow || viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;
    }

    function moveCarousel(direction, wrapAtEnd) {
      var reachedEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;
      if (direction > 0 && reachedEnd && wrapAtEnd) {
        viewport.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }

      viewport.scrollBy({ left: getStep() * direction, behavior: 'smooth' });
    }

    function stopAutoplay() {
      window.clearInterval(autoplayTimer);
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled || !hasOverflow() || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      autoplayTimer = window.setInterval(function() {
        moveCarousel(1, true);
      }, autoplayDelay);
    }

    previousButton.addEventListener('click', function() {
      moveCarousel(-1, false);
      startAutoplay();
    });

    nextButton.addEventListener('click', function() {
      moveCarousel(1, false);
      startAutoplay();
    });

    viewport.addEventListener('scroll', updateControls, { passive: true });
    carousel.addEventListener('pointerenter', stopAutoplay);
    carousel.addEventListener('pointerleave', startAutoplay);
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', function() {
      window.setTimeout(function() {
        if (!carousel.contains(document.activeElement)) startAutoplay();
      }, 0);
    });

    window.addEventListener('resize', function() {
      updateControls();
      startAutoplay();
    });

    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    updateControls();
    startAutoplay();
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initializeProductCarousels(document);
});

document.addEventListener('shopify:section:load', function(event) {
  initializeProductCarousels(event.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
function initializeHeaderInteractions(root) {
  root.querySelectorAll('.header').forEach(function(header) {
    if (header.dataset.headerReady === 'true') return;
    header.dataset.headerReady = 'true';

    var openButton = header.querySelector('[data-mobile-menu-open]');
    var dialog = header.querySelector('[data-mobile-menu-dialog]');
    var closeButton = header.querySelector('[data-mobile-menu-close]');

    if (openButton && dialog) {
      openButton.addEventListener('click', function() {
        dialog.showModal();
        openButton.setAttribute('aria-expanded', 'true');
      });

      if (closeButton) {
        closeButton.addEventListener('click', function() {
          dialog.close();
        });
      }

      dialog.addEventListener('click', function(event) {
        if (event.target === dialog) dialog.close();
      });

      dialog.addEventListener('close', function() {
        openButton.setAttribute('aria-expanded', 'false');
        openButton.focus();
      });
    }

    header.querySelectorAll('[data-predictive-search-form]').forEach(function(form) {
      var input = form.querySelector('[data-predictive-search-input]');
      var results = form.querySelector('[data-predictive-search-results]');
      var endpoint = form.dataset.predictiveSearchUrl;
      var requestController;
      var requestTimer;

      if (!input || !results || !endpoint) return;

      function closeResults() {
        results.hidden = true;
        input.setAttribute('aria-expanded', 'false');
      }

      function requestResults() {
        var term = input.value.trim();
        window.clearTimeout(requestTimer);

        if (term.length < 2) {
          if (requestController) requestController.abort();
          closeResults();
          return;
        }

        requestTimer = window.setTimeout(function() {
          if (requestController) requestController.abort();
          requestController = new AbortController();
          var url = endpoint + '?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search';

          fetch(url, { signal: requestController.signal })
            .then(function(response) {
              if (!response.ok) throw new Error('Predictive search failed');
              return response.text();
            })
            .then(function(markup) {
              var documentFragment = new DOMParser().parseFromString(markup, 'text/html');
              var section = documentFragment.querySelector('#shopify-section-predictive-search');
              results.innerHTML = section ? section.innerHTML : markup;
              results.hidden = false;
              input.setAttribute('aria-expanded', 'true');
            })
            .catch(function(error) {
              if (error.name !== 'AbortError') closeResults();
            });
        }, 220);
      }

      input.addEventListener('input', requestResults);
      input.addEventListener('focus', function() {
        if (results.innerHTML.trim() !== '' && input.value.trim().length >= 2) {
          results.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        }
      });

      form.addEventListener('focusout', function() {
        window.setTimeout(function() {
          if (!form.contains(document.activeElement)) closeResults();
        }, 0);
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initializeHeaderInteractions(document);
});

document.addEventListener('shopify:section:load', function(event) {
  initializeHeaderInteractions(event.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
function initializeMainCarts(root) {
  root.querySelectorAll('[data-main-cart]').forEach(function(cartRoot) {
    if (cartRoot.dataset.cartReady === 'true') return;
    cartRoot.dataset.cartReady = 'true';

    var updateButton = cartRoot.querySelector('[data-cart-update-button]');

    function markDirty() {
      if (updateButton) updateButton.classList.add('is-dirty');
    }

    cartRoot.querySelectorAll('[data-cart-line]').forEach(function(line) {
      var input = line.querySelector('[data-cart-quantity-input]');
      var decrease = line.querySelector('[data-cart-quantity-decrease]');
      var increase = line.querySelector('[data-cart-quantity-increase]');

      if (!input) return;

      if (decrease) {
        decrease.addEventListener('click', function() {
          input.stepDown();
          if (Number(input.value) < 0) input.value = 0;
          markDirty();
        });
      }

      if (increase) {
        increase.addEventListener('click', function() {
          input.stepUp();
          markDirty();
        });
      }

      input.addEventListener('change', markDirty);
    });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initializeMainCarts(document);
});

document.addEventListener('shopify:section:load', function(event) {
  initializeMainCarts(event.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
function initializeCollectionSort(root) {
  root.querySelectorAll('[data-collection-sort]').forEach(function(select) {
    if (select.dataset.sortReady === 'true') return;
    select.dataset.sortReady = 'true';
    select.addEventListener('change', function() {
      var form = select.closest('[data-collection-sort-form]');
      if (form) form.submit();
    });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initializeCollectionSort(document);
});

document.addEventListener('shopify:section:load', function(event) {
  initializeCollectionSort(event.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
function initializeMainProducts(root) {
  root.querySelectorAll('[data-main-product]').forEach(function(productRoot) {
    if (productRoot.dataset.productReady === 'true') return;
    productRoot.dataset.productReady = 'true';

    var variantDataElement = productRoot.querySelector('[data-product-variants]');
    var variantSelect = productRoot.querySelector('[data-product-variant-select]');
    var currentPrice = productRoot.querySelector('[data-product-current-price]');
    var comparePrice = productRoot.querySelector('[data-product-compare-price]');
    var availability = productRoot.querySelector('[data-product-availability]');
    var skuContainer = productRoot.querySelector('.product-sku');
    var skuValue = productRoot.querySelector('[data-product-sku]');
    var addButton = productRoot.querySelector('[data-product-add-button]');
    var quantityInput = productRoot.querySelector('[data-quantity-input]');
    var variants = [];

    if (variantDataElement) {
      try {
        variants = JSON.parse(variantDataElement.textContent);
      } catch (error) {
        variants = [];
      }
    }

    function activateMedia(mediaId) {
      if (!mediaId) return;
      productRoot.querySelectorAll('[data-product-media-id]').forEach(function(media) {
        media.hidden = String(media.dataset.productMediaId) !== String(mediaId);
      });
      productRoot.querySelectorAll('[data-product-thumbnail]').forEach(function(thumbnail) {
        var active = String(thumbnail.dataset.mediaTarget) === String(mediaId);
        thumbnail.classList.toggle('is-active', active);
        thumbnail.setAttribute('aria-pressed', String(active));
      });
    }

    productRoot.querySelectorAll('[data-product-thumbnail]').forEach(function(thumbnail) {
      thumbnail.addEventListener('click', function() {
        activateMedia(thumbnail.dataset.mediaTarget);
      });
    });

    function updateVariant() {
      if (!variantSelect || variants.length === 0) return;
      var variantId = Number(variantSelect.value);
      var variant = variants.find(function(item) { return Number(item.id) === variantId; });
      if (!variant) return;

      currentPrice.textContent = variant.price_formatted;
      var hasDiscount = variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price);
      comparePrice.hidden = !hasDiscount;
      comparePrice.textContent = hasDiscount ? variant.compare_at_price_formatted : '';

      availability.classList.toggle('is-unavailable', !variant.available);
      availability.querySelector('strong').textContent = variant.available ? availability.dataset.availableLabel : availability.dataset.unavailableLabel;
      addButton.disabled = !variant.available;
      addButton.querySelector('span').textContent = variant.available ? addButton.dataset.availableLabel : addButton.dataset.unavailableLabel;

      if (variant.sku) {
        skuContainer.hidden = false;
        skuValue.textContent = variant.sku;
      } else {
        skuContainer.hidden = true;
        skuValue.textContent = '';
      }

      if (variant.featured_media_id) activateMedia(variant.featured_media_id);

      var currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', currentUrl.toString());
    }

    if (variantSelect && variantSelect.tagName === 'SELECT') {
      variantSelect.addEventListener('change', updateVariant);
    }

    var decreaseButton = productRoot.querySelector('[data-quantity-decrease]');
    var increaseButton = productRoot.querySelector('[data-quantity-increase]');

    if (decreaseButton && quantityInput) {
      decreaseButton.addEventListener('click', function() {
        quantityInput.stepDown();
        if (Number(quantityInput.value) < 1) quantityInput.value = 1;
      });
    }

    if (increaseButton && quantityInput) {
      increaseButton.addEventListener('click', function() {
        quantityInput.stepUp();
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initializeMainProducts(document);
});

document.addEventListener('shopify:section:load', function(event) {
  initializeMainProducts(event.target);
});

  } catch(e) { console.error(e); }
})();
})();
